var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewServiceHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    height: "2.22rem",
    width: "2.22rem",
    alt: "Service History Icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "View_Service__History",
    "data-name": "View_Service_History"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.28,2.22A22.56,22.56,0,0,0,5.71,18.1h-2l-2.49,0a1.09,1.09,0,0,0-.94,1.67l4.67,7.73a1.09,1.09,0,0,0,1.86,0l4.76-7.7a1.08,1.08,0,0,0-.93-1.66H7.8A20.63,20.63,0,0,1,47.92,25,20.62,20.62,0,0,1,8.38,33.37a1,1,0,0,0-1.32-.51,1,1,0,0,0-.51,1.31A22.68,22.68,0,1,0,27.28,2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.28,10.07a1,1,0,0,0-1,1V22.79a3.76,3.76,0,1,0,3.66,6.5l7.13,4.28a1.06,1.06,0,0,0,.51.14,1,1,0,0,0,.86-.48,1,1,0,0,0-.34-1.38L30.18,27.7a3.75,3.75,0,0,0-2.9-5.13V11.07A1,1,0,0,0,26.28,10.07Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewServiceHistory);
export default __webpack_public_path__ + "static/media/ViewServiceHistory.2f78fb7d.svg";
export { ForwardRef as ReactComponent };